// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".g-login__forgetsuccess[data-v-e0a3530e]{padding:36px 0;text-align:center}.g-login__forgetsuccess img[data-v-e0a3530e]{width:150px}.g-login__forgetsuccess p[data-v-e0a3530e]{margin-top:4px;font-size:16px;line-height:22px;color:#333}.g-login__forgetsuccess button[data-v-e0a3530e]{cursor:pointer;width:100%;padding:13px 0;color:#fff;font-size:16px;line-height:22px;margin-top:20px;background:#386ff2;border-radius:2px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
